$(function () {
  $.ajax({ url: $('#duplicate_image_path').val() }).done(function (data) {
    $('.modal-body').html('<div class="alert alert-' + data.type + '">' + data.message + '</div>');
    if (parent && typeof parent.refresh_data == 'function') {
      parent.refresh_data();
    }
  });
});